import $ from 'jquery'

const TRIGGER_SELECTOR = '.article-list__topic-content h3'
const CONTENT_SELECTOR = '.article-list__topic-text'
const ACTIVE_CLASS = 'article-list__topic--active'

class ArticleList {
  constructor(item) {
    this.item = $(item)
    this.trigger = $(TRIGGER_SELECTOR, item)
    this.content = $(CONTENT_SELECTOR, item)
    this.listen()
  }

  listen() {
    this.trigger.on('click', () => {
      event.preventDefault()
      this.activate()
    })

    $(window).width() > 768 && this.trigger.addClass(ACTIVE_CLASS)
  }

  activate() {
    this.content.toggle()
    this.trigger.toggleClass(ACTIVE_CLASS)
  }
}

export default ArticleList
